import React from "react";
import Layout from "../layout/index";
import Button from "@mui/material/Button";
import { useNavigate, Link, useNavigation } from "react-router-dom";
import { useIntl } from "react-intl";
import UsersTable from "./users";
import OutageInformationTable from "./outage-information";
import Subscriptions from "./subscriptions";
import Bills from "./bills";
import Referrals from "./referrals";
import MarketingLeads from "./marketing";
import { FormattedMessage } from "react-intl";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Admin = (props) => {
  const intl = useIntl();

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Layout>
      <div className="container">
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              label={intl.formatMessage({
                id: "subscriptions",
              })}
              {...a11yProps(0)}
            />
            <Tab
              label={intl.formatMessage({
                id: "users",
              })}
              {...a11yProps(1)}
            />
            <Tab
              label={intl.formatMessage({
                id: "admin_bills_tab",
              })}
              {...a11yProps(2)}
            />
            <Tab
              label={intl.formatMessage({
                id: "admin_ref_tab",
              })}
              {...a11yProps(3)}
            />
            <Tab
              label={intl.formatMessage({
                id: "outage_information",
              })}
              {...a11yProps(4)}
            />
            <Tab label="Marketing" {...a11yProps(5)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <Subscriptions />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <UsersTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <Bills />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <Referrals />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={4}>
          <OutageInformationTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={5}>
          <MarketingLeads />
        </CustomTabPanel>
      </div>
    </Layout>
  );
};

export default Admin;
